import PropTypes from 'prop-types'
import styled from 'styled-components'
import { COLOR, GTR } from '@farewill/ui/tokens'

const StyledInput = styled.span`
  content: '';
  position: absolute;
  top: 3px;
  left: 3px;
  width: 18px;
  height: 18px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.9);
`

const StyledLabel = styled.label`
  position: relative;
  cursor: pointer;
  width: 42px;
  height: 24px;
  background-color: ${COLOR.GREY.LIGHT};
  border-radius: 24px;
  opacity: 1;

  ${({ disabled }) =>
    disabled &&
    `opacity: 0.5;
    cursor: default;
  `}
`

// hidden visually rather than with display: none, so screen readers and
// the keyboard can still reach it
const StyledCheckbox = styled.input`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  opacity: 0;
  cursor: inherit;

  &:focus-visible + ${StyledInput} {
    box-shadow: 0 0 0 ${GTR.XXS} ${COLOR.ACCENT.PRIMARY_60};
  }

  &:checked + ${StyledInput} {
    left: calc(100% - 3px);
    transform: translateX(-100%);
  }
`

const Switch = ({ color, disabled, handleToggle, isOn, label, testId }) => (
  <StyledLabel style={{ backgroundColor: isOn && color }} disabled={disabled}>
    <StyledCheckbox
      type="checkbox"
      onChange={handleToggle}
      checked={isOn}
      aria-label={label}
      data-testid={testId}
    />
    <StyledInput />
  </StyledLabel>
)

Switch.propTypes = {
  color: PropTypes.string,
  handleToggle: PropTypes.func.isRequired,
  isOn: PropTypes.bool,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  testId: PropTypes.string,
}

Switch.defaultProps = {
  color: COLOR.STATE.SUCCESS,
  isOn: false,
  disabled: false,
  testId: '',
}

export default Switch
